export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left: Image */}
          <div className="w-full lg:w-2/5">
            <div className="relative">
              <span className="inline-block px-4 py-1.5 border border-foreground-300/40 rounded-full font-label text-xs text-foreground-600 uppercase tracking-wider mb-6">
                About Us
              </span>
              <div className="w-full aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20bright%20minimalist%20product%20curation%20workspace%20with%20organized%20shelves%20displaying%20neatly%20folded%20fashion%20items%2C%20warm%20soft%20natural%20lighting%20from%20skylights%2C%20clean%20contemporary%20industrial%20aesthetic%20with%20white%20walls%20and%20light%20oak%20shelving%2C%20cream%20beige%20and%20soft%20taupe%20tones%20throughout%2C%20professional%20organized%20product%20storage%20environment%2C%20editorial%20interior%20photography%20with%20shallow%20depth%20of%20field%20and%20serene%20composed%20atmosphere&width=800&height=1000&seq=about-warehouse-v3&orientation=portrait"
                  alt="Modern product curation workspace with organized fashion items on light oak shelving"
                  title="Superbuy Spreadsheet - About Our Curated Product Selection Process"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-3/5">
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.15] mb-6">
              The Ultimate
              <br />
              Superbuy
              <br />
              Resource
            </h2>
            <p className="font-body text-base md:text-lg text-foreground-600 leading-relaxed mb-4 max-w-xl">
              We built the Superbuy Spreadsheet because we were tired of scattered links, outdated
              product lists, and wasting hours searching for the best deals. Our mission is simple:
              provide the most comprehensive, up-to-date, and trustworthy curated shopping resource
              available anywhere online.
            </p>
            <p className="font-body text-base text-foreground-500 leading-relaxed mb-8 max-w-xl">
              Every product in our spreadsheet is hand-selected, verified, and regularly updated.
              We include real QC photos, seller ratings, and price comparisons so you can shop
              with total confidence. Whether you are a fashion enthusiast, a budget shopper, or a
              professional reseller, the Superbuy Spreadsheet is your ultimate shopping companion.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2.5 px-8 py-4 bg-primary-500 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <span>Superbuy Spreadsheet</span>
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}